webpackJsonp([114276838955818,60335399758886],{

/***/ 142:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(292);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(142);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SiteConfig = __webpack_require__(17);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var theme = {
	  primary: _SiteConfig2.default.themeColor,
	  bg: _SiteConfig2.default.backgroundColor,
	  dark: 'rgba(0, 0, 0, 0.9)',
	  default: 'rgba(0, 0, 0, 0.7)',
	  light: 'rgba(0, 0, 0, 0.6)',
	  ultraLight: 'rgba(0, 0, 0, 0.25)',
	  transitionTime: '0.5s',
	  fontSmall: '0.9rem',
	  pattern: 'data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'40\' height=\'40\' viewBox=\'0 0 40 40\'%3E%3Cg fill-rule=\'evenodd\'%3E%3Cg fill=\'%23d02e77\' fill-opacity=\'0.15\'%3E%3Cpath d=\'M0 38.59l2.83-2.83 1.41 1.41L1.41 40H0v-1.41zM0 1.4l2.83 2.83 1.41-1.41L1.41 0H0v1.41zM38.59 40l-2.83-2.83 1.41-1.41L40 38.59V40h-1.41zM40 1.41l-2.83 2.83-1.41-1.41L38.59 0H40v1.41zM20 18.6l2.83-2.83 1.41 1.41L21.41 20l2.83 2.83-1.41 1.41L20 21.41l-2.83 2.83-1.41-1.41L18.59 20l-2.83-2.83 1.41-1.41L20 18.59z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E'
	};
	
	exports.default = theme;
	module.exports = exports['default'];

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  background: ', ';\n  border: none;\n  display: inline-flex;\n  align-items: center;\n  border-radius: ', ';\n  font-size: ', ';\n  color: white;\n  padding: ', ';\n  transition: all ', ';\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n  &:hover {\n    background: ', ';\n    cursor: pointer;\n    transform: translateY(-2px);\n  }\n  &:focus {\n    outline: none;\n  }\n  svg {\n    width: 20px;\n    height: 20px;\n    margin-right: 0.75rem;\n    fill: white;\n  }\n'], ['\n  background: ', ';\n  border: none;\n  display: inline-flex;\n  align-items: center;\n  border-radius: ', ';\n  font-size: ', ';\n  color: white;\n  padding: ', ';\n  transition: all ', ';\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n  &:hover {\n    background: ', ';\n    cursor: pointer;\n    transform: translateY(-2px);\n  }\n  &:focus {\n    outline: none;\n  }\n  svg {\n    width: 20px;\n    height: 20px;\n    margin-right: 0.75rem;\n    fill: white;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _polished = __webpack_require__(160);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.button(_templateObject, function (props) {
	  return props.theme.primary;
	}, function (props) {
	  return props.big ? '1.5rem' : '1rem';
	}, function (props) {
	  return props.big ? '1.2rem' : '1rem';
	}, function (props) {
	  return props.big ? '0.35rem 1.6rem' : '0.25rem 1.5rem';
	}, function (props) {
	  return props.theme.transitionTime;
	}, function (props) {
	  return (0, _polished.lighten)(0.05, props.theme.primary);
	});
	
	var Button = function Button(props) {
	  return _react2.default.createElement(
	    Wrapper,
	    { big: props.big },
	    props.children
	  );
	};
	
	exports.default = Button;
	module.exports = exports['default'];

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(39);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _SiteConfig = __webpack_require__(17);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SEO = function SEO(props) {
	  var postNode = props.postNode,
	      postPath = props.postPath,
	      postSEO = props.postSEO;
	
	  var title = void 0;
	  var description = void 0;
	  var image = void 0;
	  var postURL = void 0;
	  var realPrefix = _SiteConfig2.default.pathPrefix === '/' ? '' : _SiteConfig2.default.pathPrefix;
	  if (postSEO) {
	    var postMeta = postNode.frontmatter;
	    title = postMeta.title; // eslint-disable-line prefer-destructuring
	    description = postNode.excerpt;
	    image = _SiteConfig2.default.siteBanner;
	    postURL = _SiteConfig2.default.siteUrl + realPrefix + postPath;
	  } else {
	    title = _SiteConfig2.default.siteTitle;
	    description = _SiteConfig2.default.siteDescription;
	    image = _SiteConfig2.default.siteBanner;
	  }
	  image = _SiteConfig2.default.siteUrl + realPrefix + image;
	  var blogURL = _SiteConfig2.default.siteUrl + _SiteConfig2.default.pathPrefix;
	  var schemaOrgJSONLD = [{
	    '@context': 'http://schema.org',
	    '@type': 'WebSite',
	    url: blogURL,
	    name: title,
	    alternateName: _SiteConfig2.default.siteTitleAlt ? _SiteConfig2.default.siteTitleAlt : ''
	  }];
	  if (postSEO) {
	    schemaOrgJSONLD.push([{
	      '@context': 'http://schema.org',
	      '@type': 'BreadcrumbList',
	      itemListElement: [{
	        '@type': 'ListItem',
	        position: 1,
	        item: {
	          '@id': postURL,
	          name: title,
	          image: image
	        }
	      }]
	    }, {
	      '@context': 'http://schema.org',
	      '@type': 'BlogPosting',
	      url: blogURL,
	      name: title,
	      alternateName: _SiteConfig2.default.siteTitleAlt ? _SiteConfig2.default.siteTitleAlt : '',
	      headline: title,
	      image: {
	        '@type': 'ImageObject',
	        url: image
	      },
	      description: description
	    }]);
	  }
	  return _react2.default.createElement(
	    _reactHelmet2.default,
	    null,
	    _react2.default.createElement(
	      'title',
	      null,
	      _SiteConfig2.default.siteTitle
	    ),
	    _react2.default.createElement('meta', { name: 'description', content: description }),
	    _react2.default.createElement('meta', { name: 'keywords', content: 'minimal, blog, layout' }),
	    _react2.default.createElement('meta', { name: 'image', content: image }),
	    _react2.default.createElement(
	      'script',
	      { type: 'application/ld+json' },
	      JSON.stringify(schemaOrgJSONLD)
	    ),
	    _react2.default.createElement('meta', { property: 'og:locale', content: 'de_DE' }),
	    _react2.default.createElement('meta', { property: 'og:site_name', content: _SiteConfig2.default.ogSiteName }),
	    _react2.default.createElement('meta', { property: 'og:url', content: postSEO ? postURL : blogURL }),
	    postSEO ? _react2.default.createElement('meta', { property: 'og:type', content: 'article' }) : null,
	    _react2.default.createElement('meta', { property: 'og:title', content: title }),
	    _react2.default.createElement('meta', { property: 'og:description', content: description }),
	    _react2.default.createElement('meta', { property: 'og:image', content: image }),
	    _react2.default.createElement('meta', { property: 'fb:app_id', content: _SiteConfig2.default.siteFBAppID ? _SiteConfig2.default.siteFBAppID : '' }),
	    _react2.default.createElement('meta', { name: 'twitter:card', content: 'summary_large_image' }),
	    _react2.default.createElement('meta', { name: 'twitter:creator', content: _SiteConfig2.default.userTwitter ? _SiteConfig2.default.userTwitter : '' }),
	    _react2.default.createElement('meta', { name: 'twitter:title', content: title }),
	    _react2.default.createElement('meta', { name: 'twitter:url', content: _SiteConfig2.default.siteUrl }),
	    _react2.default.createElement('meta', { name: 'twitter:description', content: description }),
	    _react2.default.createElement('meta', { name: 'twitter:image', content: image }),
	    _react2.default.createElement('link', { rel: 'apple-touch-icon', sizes: '180x180', href: '/favicon/apple-touch-icon.png' }),
	    _react2.default.createElement('link', { rel: 'icon', type: 'image/png', sizes: '32x32', href: '/favicons/favicon-32x32.png' }),
	    _react2.default.createElement('link', { rel: 'icon', type: 'image/png', sizes: '16x16', href: '/favicons/favicon-16x16.png' }),
	    _react2.default.createElement('link', { rel: 'manifest', href: '/favicon/site.webmanifest' }),
	    _react2.default.createElement('link', { rel: 'mask-icon', href: '/favicon/safari-pinned-tab.svg', color: _SiteConfig2.default.themeColor }),
	    _react2.default.createElement('meta', { name: 'msapplication-TileColor', content: _SiteConfig2.default.themeColor }),
	    _react2.default.createElement('meta', { name: 'theme-color', content: _SiteConfig2.default.themeColor })
	  );
	};
	
	exports.default = SEO;
	module.exports = exports['default'];

/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  ::selection {\n    color: ', ';\n    background: ', ';\n  }\n  body {\n    background: ', ';\n    color: ', ';\n    @media ', ' {\n      font-size: 14px;\n    }\n  }\n  a {\n    color: ', ';\n    text-decoration-color: ', ';\n    transition: all ', ';\n  }\n  a:hover {\n    color: ', ';\n    text-decoration: none;\n  }\n  h1, h2, h3, h4 {\n    color: ', ';\n    a {\n      color: ', ';\n      text-decoration: none;\n    }\n  }\n  blockquote {\n    font-style: italic;\n    position: relative;\n  }\n\n  blockquote:before {\n    content: "";\n    position: absolute;\n    background: ', ';\n    height: 100%;\n    width: 6px;\n    margin-left: -1.6rem;\n  }\n  label {\n    margin-bottom: .5rem;\n    color: ', ';\n  }\n  input, textarea {\n    border-radius: .5rem;\n    border: none;\n    background: rgba(0, 0, 0, 0.05);\n    padding: .25rem 1rem;\n    &:focus {\n      outline: none;\n    }\n  }\n'], ['\n  ::selection {\n    color: ', ';\n    background: ', ';\n  }\n  body {\n    background: ', ';\n    color: ', ';\n    @media ', ' {\n      font-size: 14px;\n    }\n  }\n  a {\n    color: ', ';\n    text-decoration-color: ', ';\n    transition: all ', ';\n  }\n  a:hover {\n    color: ', ';\n    text-decoration: none;\n  }\n  h1, h2, h3, h4 {\n    color: ', ';\n    a {\n      color: ', ';\n      text-decoration: none;\n    }\n  }\n  blockquote {\n    font-style: italic;\n    position: relative;\n  }\n\n  blockquote:before {\n    content: "";\n    position: absolute;\n    background: ', ';\n    height: 100%;\n    width: 6px;\n    margin-left: -1.6rem;\n  }\n  label {\n    margin-bottom: .5rem;\n    color: ', ';\n  }\n  input, textarea {\n    border-radius: .5rem;\n    border: none;\n    background: rgba(0, 0, 0, 0.05);\n    padding: .25rem 1rem;\n    &:focus {\n      outline: none;\n    }\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  text-align: center;\n  padding: 3rem 0;\n'], ['\n  text-align: center;\n  padding: 3rem 0;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(21);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Button = __webpack_require__(111);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SEO = __webpack_require__(112);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _SiteConfig = __webpack_require__(17);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _Theme = __webpack_require__(289);
	
	var _Theme2 = _interopRequireDefault(_Theme);
	
	var _media = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; } /* eslint no-unused-expressions:0 */
	
	(0, _styledComponents.injectGlobal)(_templateObject, _Theme2.default.bg, _Theme2.default.primary, _Theme2.default.bg, _Theme2.default.default, _media.media.phone, _Theme2.default.primary, _Theme2.default.primary, _Theme2.default.transitionTime, _Theme2.default.primary, _Theme2.default.dark, _Theme2.default.dark, _Theme2.default.primary, _Theme2.default.dark);
	
	var date = new Date();
	var year = date.getFullYear();
	
	var Footer = _styledComponents2.default.footer(_templateObject2);
	
	var TemplateWrapper = function TemplateWrapper(props) {
	  var children = props.children;
	
	  return _react2.default.createElement(
	    _styledComponents.ThemeProvider,
	    { theme: _Theme2.default },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_SEO2.default, null),
	      children(),
	      _react2.default.createElement(
	        Footer,
	        null,
	        '\xA9 ',
	        year,
	        ' by ',
	        _SiteConfig2.default.siteOwner,
	        '. All rights reserved. ',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/contact' },
	          _react2.default.createElement(
	            _Button2.default,
	            null,
	            _react2.default.createElement(
	              'svg',
	              { width: '1792', height: '1792', viewBox: '0 0 1792 1792', xmlns: 'http://www.w3.org/2000/svg' },
	              _react2.default.createElement('path', { d: 'M1764 11q33 24 27 64l-256 1536q-5 29-32 45-14 8-31 8-11 0-24-5l-453-185-242 295q-18 23-49 23-13 0-22-4-19-7-30.5-23.5t-11.5-36.5v-349l864-1059-1069 925-395-162q-37-14-40-55-2-40 32-59l1664-960q15-9 32-9 20 0 36 11z' })
	            ),
	            'Contact'
	          )
	        )
	      ),
	      ';'
	    )
	  );
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-ef90c3e8c9149dc6fec6.js